import { render, staticRenderFns } from "./WanatelCloudPbxPricing.vue?vue&type=template&id=38bf03dc&"
import script from "./WanatelCloudPbxPricing.vue?vue&type=script&lang=js&"
export * from "./WanatelCloudPbxPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports